import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import GallerySection from './GallerySection';
import backgroundImage from '../assets/images/juodeliai.jpg';
import thirtyImage from '../assets/images/30.png';

const PageContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  position: relative;
  color: white;
  font-family: 'GeneralSans', sans-serif;
  overflow-y: auto;
  padding-bottom: 60px;
`;

const LoadingContainer = styled.div<{ $isLoading: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  opacity: ${props => props.$isLoading ? 1 : 0};
  visibility: ${props => props.$isLoading ? 'visible' : 'hidden'};
  transition: opacity 0.5s ease-in, visibility 0.5s ease-in;
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid rgba(255, 255, 255, 0.1);
  border-top: 3px solid #fff;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const BackgroundImage = styled.div<{ $loaded: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-image: url(${backgroundImage});
  background-size: cover;
  background-position: center;
  z-index: 0;
  opacity: ${props => props.$loaded ? 1 : 0};
  transition: opacity 0.5s ease-in;
`;

const ThirtyImage = styled.img<{ $loaded: boolean }>`
  position: fixed;
  top: 0;
  right: 0;
  width: 800px;
  height: auto;
  z-index: 1;
  opacity: ${props => props.$loaded ? 1 : 0};
  transition: opacity 0.5s ease-in;
`;

const ContentContainer = styled.div<{ $visible: boolean }>`
  position: relative;
  z-index: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: ${props => props.$visible ? 1 : 0};
  transition: opacity 0.5s ease-in;
`;

const HomePage: React.FC = () => {
  const [bgLoaded, setBgLoaded] = useState(false);
  const [thirtyLoaded, setThirtyLoaded] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Preload background image
    const bgImg = new Image();
    bgImg.src = backgroundImage;
    bgImg.onload = () => setBgLoaded(true);

    // Preload thirty image
    const thirtyImg = new Image();
    thirtyImg.src = thirtyImage;
    thirtyImg.onload = () => setThirtyLoaded(true);
  }, []);

  useEffect(() => {
    if (bgLoaded && thirtyLoaded) {
      // Add a small delay before hiding loading screen
      setTimeout(() => {
        setLoading(false);
      }, 300);
    }
  }, [bgLoaded, thirtyLoaded]);

  return (
    <PageContainer>
      <LoadingContainer $isLoading={loading}>
        <Spinner />
      </LoadingContainer>
      <BackgroundImage $loaded={bgLoaded} />
      <ThirtyImage 
        src={thirtyImage} 
        alt="30" 
        $loaded={thirtyLoaded}
      />
      <ContentContainer $visible={!loading}>
        <GallerySection />
      </ContentContainer>
    </PageContainer>
  );
};

export default HomePage;
